export default "__VITE_ASSET__RvuYbTw___"